/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section2_Li3Inputs */

const en_terms_section2_li3 = /** @type {(inputs: Terms_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON comparison, sorting, and validation`)
};

const ko_terms_section2_li3 = /** @type {(inputs: Terms_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 비교, 정렬 및 유효성 검사`)
};

const ja_terms_section2_li3 = /** @type {(inputs: Terms_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの比較、ソート、バリデーション`)
};

/**
* | output |
* | --- |
* | "JSON comparison, sorting, and validation" |
*
* @param {Terms_Section2_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section2_li3 = /** @type {((inputs?: Terms_Section2_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section2_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section2_li3(inputs)
	if (locale === "ko") return ko_terms_section2_li3(inputs)
	return ja_terms_section2_li3(inputs)
});